import { render } from "./WidgetAuth.vue?vue&type=template&id=45f55ddb&scoped=true"
import script from "./WidgetAuth.vue?vue&type=script&lang=js"
export * from "./WidgetAuth.vue?vue&type=script&lang=js"

import "./WidgetAuth.vue?vue&type=style&index=0&id=45f55ddb&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45f55ddb"]])

export default __exports__